<template>
    <div>
        <table class="tabela" :key="keyTable">
          <thead>
            <tr>
              <th id="quantity">{{ $gettext("VALUE_RANGE_QUANTITY_TABLE_LABEL") }}</th>
              <th id="price">{{ $gettext("VALUE_RANGE_VALUE_TABLE_LABEL") }}</th>
              <th id="type">{{ $gettext("TYPE") }}</th>
              <th id="action">{{ $gettext("ACTIONS") }}</th>
            </tr>
            <tr>
              <th scope="col">
                <jt-decimal-input standout  float-label="Quantidade" name="quantidade" v-model="objectInsert.quantity" color="primary" inverted/>
              </th>
              <th scope="col">
                <jt-decimal-input standout  float-label="Valor" name="valor" v-model="objectInsert.value" color="primary" inverted/>
              </th>
              <th scope="col">
                <jt-select
                  class="tw-pr-4"
                  v-model="objectInsert.contractItemBillingType"
                  :label="$gettext('TYPE')"
                  :options="contractItemBillingTypeOptions"
                />
              </th>
              <th scope="col">
                <em class="mdi mdi-plus-circle mdi-24px custom-cursor" @click="addRange"></em>
              </th>
            </tr>
          </thead>
          <tbody>
              <tr :key="range.id" v-for="range in valueRange">
                <td>{{range.quantity}}</td>
                <td v-jtech-text-double="'currency'">{{range.value}}</td>
                <td>{{getContractItemBillingTypeText(range.contractItemBillingType)}}</td>
                <td>
                  <em class="mdi mdi-delete mdi-24px custom-cursor" @click="removeRange(range.id)"></em>
                </td>
              </tr>
            <tr v-if="valueRange.length == 0">
              <td colspan="3">
                <div>
                  <span>{{ $gettext("VALUE_RANGE_EMPTY") }}</span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
    </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { JtCrud, JtTextInput, JtSelect, JtInput, JtDecimalInput } from 'jtech-webcomps'
const { modal } = JtCrud
import 'leaflet/dist/leaflet.css'
import { repository } from 'jtech'
import { ContractItemBillingType } from 'src/shared/inf-tabela-descricao/ContractItemBillingType.enum'

@Component({
  components: {
    JtTextInput,
    JtSelect,
    JtInput,
    JtDecimalInput
  },
  mixins: [modal],
  name: 'ValueRangeFormTable',
  props: {
    keyTable: {},
    rangeToInsert: {},
    valueRange: []
  }
})
class ValueRangeFormTable extends Vue {
  objectInsert = {};
  quantity = null;
  value = null;
  contractItemBillingTypeOptions = []

  async mounted () {
    const response = await repository.resolve('contractItemBilling.getBontractItemBillingType')
    this.contractItemBillingTypeOptions = response[0].relacionamentos.contractItemBillingType
  }

  getContractItemBillingTypeText (contractItemBillingType) {
    if (contractItemBillingType) { return this.$gettext(`CONTRACT_ITEM_BILLING_TYPE.${contractItemBillingType}`) }
    return ''
  }

  created () {
    this.objectInsert = this.rangeToInsert
  }

  addRange () {
    this.$emit('addRange', this.objectInsert)
    console.log(this.objectInsert.contractItemBillingType)
    this.objectInsert.quantity = null
    this.objectInsert.value = null
    this.objectInsert.contractItemBillingType = null
  }

  removeRange (id) {
    this.$emit('removeRange', id)
  }
}
export default ValueRangeFormTable
</script>
<style lang="stylus" scoped>
table {
  table-layout: fixed;
  width: 100%;
  border-collapse: collapse;
}

th, td {
  border: 1px solid #ddd;
  padding: 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

th:nth-child(1) {
  width: 30%;
}

th:nth-child(2) {
  width: 30%;
}
th:nth-child(3) {
  width: 30%;
}
th:nth-child(4) {
  width: 10%;
}

.tabela {
  width: 100%;
  border-collapse: collapse;
  margin: 20px auto;
}

.tabela th, .tabela td {
  padding: 12px;
  text-align: left;
}

.tabela th {
  background-color: #F2F4F5;
  border-bottom: 2px solid #dddddd;
}

.tabela tr:hover {
  background-color: #f0f0f0;
}

.table-row-divider {
  border-bottom: 1px solid #ddd;
}
.custom-cursor {
  cursor: pointer;
}
.medium-height {
  height: 350px;
}
.value-range-area {
  position: relative;
  z-index: 99999
}
.value-range-area-title {
  font-size: 14pt;
  font-weight: bold;
}
.value-range-input {
  border-radius: 5px;
  border: 1px solid lightgray;
  width: 80%;
  height: 40px;
}
</style>
